<template>
	<div class="template-box">
		<div class="Loading-box">
			<img src="../../assets/loading.gif" alt="TOZO loading img"/>
			<div v-if="LoadingText" class="Loading-text">{{ $t('loading') }}...</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'Loading',

	props: {
		Loading: {
			type: Boolean,
			default: false,
		},
		LoadingText: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			
		}
	},
	
	// 监听
	watch: {
		// "Post_List": {
		// 	handler: function (newValue, oldValue) {
		// 		this.list = this.Post_List
		// 	},
		// 	deep: true
		// },
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
	  
	},
  
	mounted() {
		
	},
  
	methods:{
		
	}
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.template-box{
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	@media screen and (min-width: 1024px) {
		.Loading-box{
			padding: 10px 10px;
			width: 100%;
			height: 100%;
			min-height: 300px;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			color: #999999;
			font-size: 15px;
			img{
				width: 100%;
				max-width: 60px;
			}
			.Loading-text{
				margin-top: 15px;
			}
		}
	}
	@media screen and (max-width: 1024px) {
		.Loading-box{
			padding: 10px 10px;
			width: 100%;
			height: 100%;
			min-height: calc(100vh - 288px);
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			color: #999999;
			font-size: 13px;
			img{
				width: 100%;
				max-width: 40px;
			}
			.Loading-text{
				margin-top: 15px;
			}
		}
	}
</style>
